/** 区域5 · 页脚：线框分隔线 + 极简信息 + 霓虹社交图标 */
export function Footer() {
  return (
    <footer className="mx-auto mt-20 max-w-6xl px-5 pb-10">
      <div className="wire-divider mb-7" />
      <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
        <p className="m-0 text-[12.5px] text-white/35">
          魔方学院 · 纯前端 · 教学演示全部经数学验证
        </p>
        <div className="flex items-center gap-4">
          <a
            href="https://github.com"
            target="_blank"
            rel="noreferrer"
            aria-label="GitHub"
            className="text-white/40 transition-all hover:text-[#00e5ff]"
            style={{ filter: 'drop-shadow(0 0 0 transparent)' }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.filter = 'drop-shadow(0 0 8px rgba(0,229,255,0.8))')
            }
            onMouseLeave={(e) => (e.currentTarget.style.filter = 'drop-shadow(0 0 0 transparent)')}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 .5C5.65.5.5 5.65.5 12c0 5.08 3.29 9.39 7.86 10.91.58.11.79-.25.79-.55v-2.17c-3.2.7-3.87-1.36-3.87-1.36-.52-1.33-1.28-1.68-1.28-1.68-1.04-.72.08-.7.08-.7 1.15.08 1.76 1.19 1.76 1.19 1.03 1.75 2.69 1.25 3.34.95.1-.74.4-1.25.72-1.54-2.55-.29-5.24-1.28-5.24-5.68 0-1.26.45-2.28 1.19-3.09-.12-.29-.52-1.46.11-3.05 0 0 .97-.31 3.18 1.18a11.1 11.1 0 0 1 5.8 0c2.2-1.49 3.17-1.18 3.17-1.18.63 1.59.23 2.76.11 3.05.74.81 1.19 1.83 1.19 3.09 0 4.41-2.69 5.38-5.25 5.67.41.35.77 1.05.77 2.12v3.14c0 .3.21.67.8.55A11.5 11.5 0 0 0 23.5 12C23.5 5.65 18.35.5 12 .5z" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
}
